import {Component, Input, OnInit} from "@angular/core";
import {DialogService} from "../../../ng2-bootstrap-modal/dialog.service";
import {DialogComponent} from "../../../ng2-bootstrap-modal/dialog.component";
import {User} from "../../user/user";

@Component({
    selector: 'db-changelog',
    templateUrl: './whats-new-dialog.component.html',
    styleUrls: ['./whats-new-dialog.component.scss'],
    standalone: false
})
export class WhatsNewDialogComponent extends DialogComponent<null, null> implements OnInit {
  public todaysDate: Date;
  public whatsNewContent: any = '';
  @Input() user: User;
  @Input() data: any;

  constructor(
    private _dialogService: DialogService
  ) {
    super(
      _dialogService
    );
  }

  ngOnInit() {
    this.todaysDate = new Date(this.data.date);
    this.whatsNewContent = this.data.content;
  }

}
